
import React, { useEffect, useState } from "react"
import { getReasonsData, postMoodData } from "../service/api"

import '../components/css/Dashboard-freepane.css'

const FreezePane = () => {


    const [data, setData] = useState([]);

    const [flag, setFlag] = useState(false)

    const [reasonArray, setReasonArray] = useState([]);

    const [mood, setMood] = useState(0)

    const [comment, setComment] = useState()

    const [tickView, setTickView] = useState('')

    const [moodValidation, setMoodValidation] = useState();

    const [reasonValidation, setReasonValidation] = useState();

    const [display, setDisplay] = useState(true)

    let arr = []

    useEffect(() => {

        fetchApi()

    }, [])

    const fetchApi = async () => {

        const resp = await getReasonsData()

        //

        if (resp?.data?.ResponseData.length > 0) setData(resp.data.ResponseData)

        let arr = []

        resp?.data?.ResponseData.map((reason) => {

            let obj = {
                id: reason.id,
                clicked: false
            }

            arr.push(obj)
        })

        setReasonArray(arr)

    }


    const reasonClickNew = (event, i) => {

        let arr = reasonArray;

        arr[i] = { ...arr[i], clicked: !arr[i].clicked }

        setFlag(!flag)

        setReasonArray(arr)

    }

    const validation = () => {

        if (mood == 0) {

            setMoodValidation("Mood is required");
        }

        let reasonFault = reasonArray.filter((el) => el.clicked == true)

        if (reasonFault.length == 0) {
            setReasonValidation("Reason is required")

        }
        if (mood == 0 || reasonFault.length == 0) {
            return false
        }

        submitClicked()
    }



    const submitClicked = async () => {

        let idArr = [], set = false

        reasonArray.filter((el) => { if (el.clicked) { idArr.push(el.id); set = true } })

        let obj = {

            comment: comment,
            reasons: { ...idArr },
            mood: mood
        }



        //

        let resp

        if (set) {

            resp = await postMoodData(obj);
        }

     



        // if (resp.data.Success == 200 && mood != 0 && set) 
        setDisplay(false)

    }

    const reasonBody = () => {

        try {

            return (

                data.map((datum, i) => {

                    return (<>


                        <div className={`custom-col-20 ${reasonArray[i].clicked ? 'position-relative' : null} `}>
                            <button onClick={(e) => { reasonClickNew(e, i); setReasonValidation('') }} value={datum.id} type="button" className={`${reasonArray[i].clicked ? `freezepane-button-select` : `freezepane-button-style`} medium-text font-14 mb-3`}>{datum.name}</button>
                            {reasonArray[i].clicked ? <img src="/Images/Tick.png" className="tick-position" /> : null}

                        </div>

                    </>)


                }))
        }
        catch (e) {


        }


    }


    if (display) {

        return (
            <>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 bg-color px-5"></div>
                        <div className="modal fade show pop-bg" id="exampleModal" style={{ display: "block" }} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="false" aria-modal="true" role="dialog">
                            <div className="modal-dialog goal-popup modal-dialog-centered">
                                <div className="modal-content px-5">
                                    <div className="modal-body text-center py-4">
                                        <div>
                                            <p className="tt-bold font-18 text-blue my-5">How was your mood in the past week?</p>
                                            <div className="row justify-content-center">
                                                <div className={`col-md-2 ${(mood == 1) ? 'position-relative' : null}`}>
                                                    <h1 className="bold-text font-14"><img onClick={() => { setMood(1); setMoodValidation("") }} src="/Images/Happy.png" className={`freeze-Emoji-img btn p-0 ${mood == 1 ? `freezepane-emoji-select` : null} `} /> {(mood == 1) ? <img src="/Images/Tick.png" className=" tick-position-2" /> : null} Happy</h1>
                                                </div>
                                                <div className={`col-md-2 text-center ${(mood == 3) ? 'position-relative' : null}`}>
                                                    <h1 className="bold-text font-14 me-2"> <img src="/Images/Ok.png" onClick={() => { setMood(3); setMoodValidation("") }} className={`freeze-Emoji-img btn p-0 me-2" ${mood == 3 ? `freezepane-emoji-select` : null}`} />{(mood == 3) ? <img src="/Images/Tick.png" className=" tick-position-2" /> : null}Ok</h1>
                                                </div>
                                                <div className={`col-md-2 ${(mood == 2) ? 'position-relative' : null} `}>
                                                    <h1 className="bold-text font-14"><img onClick={() => { setMood(2); setMoodValidation("") }} src="/Images/Sad.png" className={`freeze-Emoji-img btn p-0 ${mood == 2 ? `freezepane-emoji-select` : null}`} /> {(mood == 2) ? <img src="/Images/Tick.png" className=" tick-position-2" /> : null}Sad</h1>
                                                </div>
                                            </div>
                                            <span style={{ color: "red" }}>{moodValidation}</span>
                                            <p className="bold-text font-15 text-blue my-4">Select a reason (multiple choice possible)</p>
                                        </div>

                                        <div className="row">
                                            {reasonBody()}
                                        </div>
                                        <span style={{ color: "red" }}>{reasonValidation}</span>

                                        <textarea className="freezepane-textarea-style form-control custom-textfield font-14 medium-text my-4" placeholder="Your Comment (optional)" onChange={(e) => { setComment(e.target.value) }} defaultValue={""} />
                                        <div className="col-md-12 d-flex justify-content-end mt-3">
                                            <button onClick={() => { validation() }} type="button" className="btn hive-btn-primary">Submit</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
    else {
        return (
            <></>
        )

    }


}

export default FreezePane